import logService from '../wss/logService3';
import CoreBase from './CoreBase';

export default class CacheBase2 extends CoreBase {
    _items = [];
    _name = 'CacheBase2';

    /**
     * Guards against undefined _items.
     */
    _check = () => {
        if (!this._items) this._items = [];
    };

    /**
     * Returns all items.
     */
    getAll = () => {
        try {
            this._check();
            return [...this._items];
        } catch (error) {
            logService.logError(`${this._name}.getAll: ${error.message}`);
            return [];
        }
    };

    /**
     * Returns item by rk, or null.
     */
    get = (rk) => {
        try {
            this._check();
            return this._items.find((e) => e.rk === rk) ?? null;
        } catch (error) {
            logService.logError(`${this._name}.get: ${error.message}`);
            return null;
        }
    };

    /**
     * Removes item by rk.
     * Returns true if mutated.
     */
    delete = (rk) => {
        try {
            this._check();

            const idx = this._items.findIndex((e) => e.rk === rk);
            if (idx === -1) return false;
            this._items.splice(idx, 1);
            return true;
        } catch (error) {
            logService.logError(`${this._name}.delete: ${error.message}`);
            return false;
        }
    };

    /**
     * Replaces all items.
     */
    setCache = (items) => {
        try {
            this._items = items;
        } catch (error) {
            logService.logError(`${this._name}.setCache: ${error.message}`);
        }
    };

    /**
     * Clears all items.
     */
    clear = () => {
        this.setCache([]);
    };

    /**
     *
     *
     * @returns true when cache is empty
     */
    isEmpty() {
        return this.count() === 0;
    }

    /**
     * Returns item count.
     */
    count = () => {
        try {
            this._check();
            return this._items.length;
        } catch (error) {
            logService.logError(`${this._name}.count: ${error.message}`);
            return 0;
        }
    };

    /**
     * add item to cache as first element
     *
     * @param {*} item
     */
    add = (item) => {
        this._check();
        // new entries added to top
        this._items.unshift(item);
    };

    /**
     * finds object by rk if found updates cache with it
     *
     * @param {*} item object
     * @returns true when updated
     */
    update = (item) => {
        try {
            this._check();

            const idx = this._items.findIndex((e) => e.rk === item.rk);
            if (idx === -1) return false;

            this._items[idx] = item;

            return true;
        } catch (error) {
            this.logError('update', error.message);
        }
    };

    /**
     * Adds or updates entries in cache.
     * New entries are added to the top.
     *
     *
     * Returns true if any entry was mutated.
     */
    addOrUpdate = (data) => {
        try {
            this._check();
            let mutated = false;

            data.forEach((item) => {
                const idx = this._items.findIndex((e) => e.rk === item.rk);
                if (idx !== -1) {
                    this._items[idx] = item;
                } else {
                    // new entries added to top
                    this._items.unshift(item);

                    // this._items.push(item);
                }

                // this.logDebug('addOrUpdate', `${item.rk}`);

                mutated = true;
            });

            return mutated;
        } catch (error) {
            logService.logError(`${this._name}.addOrUpdate: ${error.message}`);
            return false;
        }
    };
}
